import { Box, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { toPercent } from "src/utils/toPercent";

interface Props {
  threshold: number[];
  score: number;
}

const ScoreMeter = ({ score, threshold }: Props) => {
  const minScore = useMemo(() => threshold[0], [threshold]);
  const maxScore = useMemo(() => threshold[threshold.length - 1], [threshold]);
  const userScore = toPercent(score, minScore, maxScore);
  const thresholdPercents = useMemo(
    () => threshold.map((t) => toPercent(t, minScore, maxScore)),
    [maxScore, minScore, threshold]
  );

  return (
    <Stack>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: 15,
          background: "linear-gradient(90deg, #FFF 0%, #035253 100%)",
          borderRadius: 24,
        }}
      >
        <Stack
          gap={0.5}
          sx={{
            position: "absolute",
            left: `${userScore}%`,
            top: -40,
            transform: "translateX(-50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transition: "left 300ms ease-out",
            width: "max-content",
          }}
        >
          <Typography fontWeight={600} color="#ffffff">
            {score}
          </Typography>
          <Box
            sx={{
              "&:before": {
                content: '""',
                width: 0,
                height: 0,
                borderLeft: 8 + "px solid transparent",
                borderRight: 8 + "px solid transparent",
                borderTop: 8 + "px solid white",
                marginBottom: 4,
              },
            }}
          />
        </Stack>
      </Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ position: "relative" }}
      >
        {threshold.map((val, idx) => (
          <Typography
            color="#ffffff"
            key={val}
            sx={{
              position: "absolute",
              left: `${thresholdPercents[idx]}%`,
              transform: "translateX(-50%)",
              whiteSpace: "nowrap",
            }}
          >
            {val}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};

export default ScoreMeter;
